import { render, staticRenderFns } from "./AvaliacaoInstitucional.vue?vue&type=template&id=23c39b02&scoped=true"
import script from "./AvaliacaoInstitucional.vue?vue&type=script&lang=js"
export * from "./AvaliacaoInstitucional.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoInstitucional.vue?vue&type=style&index=0&id=23c39b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c39b02",
  null
  
)

export default component.exports